export default __webpack_public_path__ + "static/media/key.1c5eb1dc.svg";